import Result from "slotworks/model/gameplay/records/results/result";

export class FreespinComebackResult extends Result {
    public resultType: string = "FreespinComebackResult";
}
